import {
  FlightRoomDetail,
  FlightRoomSearchSummary,
  FlightRoomSummary,
  FlightStatus,
  Pagination,
} from '@connect-x-app/shared-domain-models';
import { API_FACTORY, DEFAULT_PAGE_SIZE } from '@connect-x-app/shared-utils';

import { parseRequestOptionsToUrlParams, QueryParameters } from '../utils';
import { HttpClient } from '../utils/http';
import { RequestOptions } from './requestOptions';

export const getFlightRooms = (query: FlightRoomsQueryOptions): Promise<Pagination<FlightRoomSummary>> => {
  return HttpClient.get<Pagination<FlightRoomSummary>>(API_FACTORY.v4('rooms'), parseFlightRoomsQueryOptions(query));
};

export const getTasks = (query?: TasksQueryOptions): Promise<Pagination<FlightRoomSummary>> => {
  return HttpClient.get<Pagination<FlightRoomSummary>>(API_FACTORY.v2('tasks'), parseTasksQueryOptions(query));
};

export const getFlightRoomById = (roomId: string): Promise<FlightRoomDetail> => {
  return HttpClient.get<FlightRoomDetail>(API_FACTORY.v4(`rooms/${encodeURIComponent(roomId)}`));
};

export const getResolvedRoomIdByExternalId = (externalRoomId: string): Promise<{ id: string }> => {
  return HttpClient.get<{ id: string }>(API_FACTORY.v4(`rooms/resolve/${encodeURIComponent(externalRoomId)}`));
};

export type FlightRoomsQueryOptions = RequestOptions & {
  status?: FlightStatus;
  workstationId?: string;
};

export type TasksQueryOptions = RequestOptions & {
  workstationId?: string;
};

export const flightRoomsQuery: FlightRoomsQueryOptions = {
  limit: DEFAULT_PAGE_SIZE,
};

export const parseTasksQueryOptions = (options?: TasksQueryOptions): QueryParameters => {
  const params: QueryParameters = {
    ...parseRequestOptionsToUrlParams(options),
  };

  return {
    ...params,
    filter: {
      workstationId: options?.workstationId,
    },
  };
};

export type FlightRoomsSearchQueryOptions = RequestOptions & {
  query: string;
};

export const parseFlightRoomsSearchQueryOptions = (options: FlightRoomsSearchQueryOptions): QueryParameters => {
  const params: QueryParameters = {
    ...parseRequestOptionsToUrlParams(options),
  };

  return {
    ...params,
    query: options.query,
    sort: {
      direction: 'asc',
      field: 'schedule.std',
    },
  };
};

export const searchFlightRooms = (options: FlightRoomsSearchQueryOptions): Promise<Pagination<FlightRoomSearchSummary>> => {
  return HttpClient.get<Pagination<FlightRoomSearchSummary>>(
    API_FACTORY.v4('rooms/search'),
    parseFlightRoomsSearchQueryOptions(options),
  );
};

export const parseFlightRoomsQueryOptions = (options?: FlightRoomsQueryOptions): QueryParameters => {
  const params: QueryParameters = {
    ...parseRequestOptionsToUrlParams(options),
  };

  return {
    ...params,
    filter: {
      status: options?.status,
      workstationId: options?.workstationId,
    },
  };
};
